import http from './lib.js'
import { configHandler, httpHandler, dataHandler } from './handler.js'

function aiPost(api = '', data = {}) {
	return new Promise((resolve, reject) => {
		try {
			const xhr = new XMLHttpRequest();
			const url = 'https://www.anyapi.work' + api;
			const parse = function(text = '') {
				try {
					return JSON.parse(text);
				} catch (err) {
					return text;
				}
				return text;
			};
			xhr.open('POST', url, true);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.onreadystatechange = function() {
				if (xhr.readyState == 4) {
					if (xhr.status == 200) {
						resolve({
							status: 'success',
							data: parse(xhr.responseText || '')
						});
					} else {
						resolve({
							status: 'error',
							data: null
						});
					}
				}
			}
			xhr.send(JSON.stringify(data));
		} catch (err) {
			resolve({
				status: 'error',
				data: err
			});
		}
	});
}

export const ai = {
	chat: function(data = {}, mode = 'fast') {
		// 响应快，版本低
		if (mode === 'fast') {
			return aiPost('/stream_chat', data);
		}
		// 响应慢，版本高
		if (mode === 'slow') {
			return aiPost('/stream_chatv2', data);
		}
		return {
			status: 'error',
			data: null
		};
	},
	query: function(data = {}) {
		return aiPost('/query', data);
	}
};

export const custom = {
	// 获取文件
	xml: function(url = '') {
		return httpHandler.get(url).then(text => {
			let status = 'error';
			let data = '';
			if (text) {
				status = 'success';
				data = text;
			}
			return {
				status,
				data
			};
		});
	},
    // 获取方程式库/序列数据
    phamula: function(url = '') {
    	return httpHandler.get(url).then(text => {
    		let status = 'error';
    		let data = {};
    		if (text && typeof text === 'object') {
    			status = 'success';
    			data = text;
    		}
    		return {
    			status,
    			data
    		};
    	});
    },
    // 获取聊天记录
    getChatMessagesList: function(url = '', req = {}) {
    	return httpHandler.post(url, req);
    }
};

export const user = {
	login: function(data = {}) {
        const { APP_ID } = configHandler();
		data.app_id = data.app_id || APP_ID;
		data.language = data.language || '1';
		return http.post('/home/user/login', data);
	},
	register: function(data = {}) {
        const { APP_ID } = configHandler();
		data.app_id = data.app_id || APP_ID;
		return http.post('/home/user/register', data);
	},
	profile: function() {
		return http.post('/home/user/profile', {}).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.userHandler(res.data);
			}
			return res;
		});
	},
	public_profile: function(user_id = '') {
		return http.post('/home/user/public_profile', { user_id }).then(res => {
			if (res.status === 'success') {
				res.data['user_id'] = user_id;
				res.data = dataHandler.userHandler(res.data);
			}
			return res;
		});
	},
	set_profile: function(data = {}) {
		return http.post('/home/user/set_profile', data);
	},
	punch_daka: function(data = {}) {
		return http.post('/home/user/punch_daka', data);
	},
	report_bug: function(content = '') {
		return http.post('/home/user/report_bug', { content });
	},
	liked_object_list: function() {
		return http.post('/home/user/liked_object_list', {});
	},
	send_mobile_verifycode: function(mobile = '') {
		return http.post('/home/user/send_mobile_verifycode', { mobile });
	},
	check_mobile_verifycode: function(data = {}) {
		return http.post('/home/user/check_mobile_verifycode', data);
	}
};

export const event = {
	search: function(data = {}) {
		return http.post('/home/event/search', data).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.addBaseUrl(res.data, 'picture');
				res.data = dataHandler.strToNum(res.data, ['booked_num', 'checkedin_num', 'is_canceled', 'length', 'max_num']);
				res.data = res.data.map(v => Object.assign(v, dataHandler.eventDescription(v.description)));
			}
			return res;
		});
	}
};

export const tuwen = {
	detail: function(tuwen_id = '') {
		tuwen_id = tuwen_id || store.state.tuwen_id;
		return http.post('/home/tuwen/detail', { tuwen_id }).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.tuwenHandler(res.data);
			}
			return res;
		});
	}
};

export const order = {
	add: function(data = {}) {
		return http.post('/home/order/add', data);
	},
    addWithFile: function(formData) {
        return http.post('/home/order/add', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
	addDocToOrder: function(formData) {
        return http.post('/home/order/add_doc_to_order', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
	lists: function(data = {}) {
		return http.post('/home/order/lists', data).then(res => {
			if (res.status === 'success') {
				if (res.data.list && res.data.list.length) {
					res.data.list = dataHandler.strToNum(res.data.list, ['quantity', 'is_digital', 'is_fulfilled', 'is_single_product', 'is_payment_complete']);
				}
			}
			return res;
		});
	}
};


export const everify = {
    generate_code: function(data = {}) {
        return http.post('/home/everify/generate_code', data);
    }
};

export const object = {
	detail: function(object_id = '') {
		return http.post('/home/object/detail', { object_id }).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.objHandler(res.data);
			}
			return res;
		});
	},
	is_liked: function(object_id = '') {
		return http.post('/home/object/is_liked', { object_id }).then(res => {
			if (res.status === 'success') {
				res.data.is_liked = Number(res.data.is_liked);
			}
			return res;
		});
	},
	add_like: function(object_id = '') {
		return http.post('/home/object/add_like', { object_id });
	},
	del_like: function(object_id = '') {
		return http.post('/home/object/del_like', { object_id });
	},
	// like_list: function(object_id = '') {
	// 	return http.post('/home/object/like_list', { object_id });
	// },
	// like_count: function(object_id = '') {
	// 	return http.post('/home/object/like_count', { object_id });
	// },
	detail_list: function(object_ids = '') {
		return http.post('/home/object/detail_list', { object_ids }).then(res => {
			if (res.status === 'success') {
				res.data = res.data.map(object => dataHandler.objHandler(object));
			}
			return res;
		});
	}
};

export const message = {
	send: function(data = {}) {
		return http.post('/home/message/send', data).then(res => {
			if (res.status === 'success') {
				res.data.message_id = String(res.data.message_id);
			}
			return res;
		});
	}
};

export const phamula = {
	detail: function(phamula_id = '', host_name = ''){
		return http.post('/home/phamula/detail', { phamula_id,host_name}).then(res => {
			if (res.status === 'success') {
				if (res.data) {
					try {
						res.data.obj_relation_json = JSON.parse(res.data.obj_relation_json);
						res.data.obj_relation_json.type = Number(res.data.obj_relation_json.type);
						res.data.obj_relation_json.layer = dataHandler.treeLayer(res.data.obj_relation_json.jsonStr);
					} catch(err) {
						res.data.obj_relation_json = {
							jsonStr: {},
							layer: 0,
							name: '',
							type: -1
						};
					}
					res.data.type = res.data.obj_relation_json.type;
					res.data.name = res.data.obj_relation_json.name;
				} else {
					res.status = 'error';
					res.data = null;
				}
			}
			return res;
		});
	},
	host_detail: function(host_name = '', page_tag = '') {
		return http.post('/home/phamula/host_detail', { host_name, page_tag }).then(res => {
			if (res.status === 'success') {
				if (res.data) {
					try {
						res.data.obj_relation_json = JSON.parse(res.data.obj_relation_json);
						res.data.obj_relation_json.type = Number(res.data.obj_relation_json.type);
						res.data.obj_relation_json.layer = dataHandler.treeLayer(res.data.obj_relation_json.jsonStr);
					} catch(err) {
						res.data.obj_relation_json = {
							jsonStr: {},
							layer: 0,
							name: '',
							type: -1
						};
					}
					res.data.type = res.data.obj_relation_json.type;
					res.data.name = res.data.obj_relation_json.name;
					// Add base URL to obj_photo (similar to objHandler)
					res.data.obj_photo = dataHandler.addBaseUrl(res.data.obj_photo);
				} else {
					res.status = 'error';
					res.data = null;
				}
			}
			return res;
		});
	}
};

export const booking = {
	add: function(data = {}) {
		return http.post('/home/booking/add', data);
	},
	search: function(data = {}) {
		return http.post('/home/booking/search', data).then(res => {
			if (res.status === 'success') {
				res.data = dataHandler.strToNum(res.data, ['is_paid', 'is_checkedin']);
			}
			return res;
		});
	},
	pay_result: function(data = {}) {
		return http.post('/home/booking/pay_result', data);
	}
};

export const uniqueview = {
	get_id_from_randvid: function(randvid = '') {
		// 此处access_token为access_t并且固定值为'yeah'(因为网页可能是 公开的)
		const access_t = 'yeah';
		return http.post('/home/uniqueview/get_id_from_randvid', { access_t, randvid }).then(res => {
			if (res.status === 'success') {
				res.data.notes = dataHandler.decodeHtml(res.data.notes);
				res.data.notes = dataHandler.isJson(res.data.notes) ? JSON.parse(res.data.notes) : res.data.notes;
				[ 'tuid', 'crm_id', 'tpo_id' ].forEach(key => res.data[key] = dataHandler.isPositiveInteger(res.data[key]) ? res.data[key] : '');
				[ 'is_pop', 'is_share', 'is_watermark', 'is_targeted', 'operations' ].forEach(key => res.data[key] = dataHandler.isZeroAndInteger(res.data[key]) ? Number(res.data[key]) : 0);
			}
			return res;
		});
	}
};